import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Text } from '../../components';
import { TaxProfileForm } from '../TaxProfileForm'; 
import { CnpjProfileForm } from './CnpjProfileForm';
 

const NovoPerfil = () => {
  const location = useLocation();
  const tipo = new URLSearchParams(location.search).get('tipo');

  if (tipo === 'cpf') return <TaxProfileForm />;
  if (tipo === 'cnpj') return <CnpjProfileForm />;

  return (
    <Box p={4}>
      <Text fontSize={4} fontWeight="bold">
        Tipo de cadastro inválido
      </Text>
      <Text>Retorne e escolha se deseja cadastrar um perfil CPF ou CNPJ.</Text>
    </Box>
  );
};

export default NovoPerfil;
